import Image from "next/image";
import React from "react";
import { styled } from "@acko-tech/building-blocks.ui.common";
import { resolvePath } from "@utils/resolvePath";

const ParentWrapper = styled.div`
  box-sizing: border-box
  display: flex;
  width: 80px;
  height: 80px;
  padding: 8.333px 10px 11.409px 10px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  position: realtive;
  ${(props) => props.parentWrapperStyles}
  @media(min-width: 767px) {
  width: 88px;
  height: 88px;
  padding: 9.167px 11px 12.549px 11px;
  }
`;

export default function ImageContainer(props: any) {
  const {
    imgSrc,
    width,
    height,
    alt,
    styles,
    showParentWrapper = false,
    parentWrapperStyles,
    isResolvePath = false,
    ...restProps
  } = props;

  if (!imgSrc) {
    return null;
  }

  return showParentWrapper ? (
    // In cases where image is wrapped in an Image container
    <ParentWrapper>
      <div
        style={{
          width: "100%",
          height: "100%",
          position: "relative"
        }}
      >
        <Image
          src={isResolvePath ? resolvePath(imgSrc) : imgSrc}
          layout="fill"
          objectFit="contain"
          alt={alt}
          {...restProps}
        />
      </div>
    </ParentWrapper>
  ) : (
    <Image
      src={isResolvePath ? resolvePath(imgSrc) : imgSrc}
      width={width || 28}
      height={height || 28}
      alt={alt}
      style={styles}
      {...restProps}
    />
  );
}
